import React from "react";
import { InputBase } from "../ui/input-base";

const PhoneInput = React.forwardRef(
  ({ className, value, onChange, error, ...props }, ref) => {
    const handleChange = (e) => {
      const inputValue = e.target.value;
      const cleaned = inputValue.replace(/\D/g, "");
      if (cleaned.length <= 10) {
        onChange(cleaned);
      }
    };

    const formatPhoneNumber = (value) => {
      let phone = ("" + value).replace(/\D/g, "");
      const match = phone.match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
      if (match) {
        phone = `${match[1]}${match[2] ? "-" : ""}${match[2]}${
          match[3] ? "-" : ""
        }${match[3]}`;
      }
      return phone;
    };

    return (
      <div className="flex">
        <div className="bg-gray-100 rounded-l-lg border border-border px-3 border-r-0 flex items-center justify-center">
          <span className="text-sm font-medium text-gray-500">(+1)</span>
        </div>
        <InputBase
          type="phone"
          value={value ? formatPhoneNumber(value) : ""}
          onChange={handleChange}
          className={className}
          placeholder="999-999-9999"
          siblingLeft
          {...props}
        />
      </div>
    );
  }
);
PhoneInput.displayName = "PhoneInput";

export { PhoneInput };
